export * from "./submit-product-card";
